import { render, staticRenderFns } from "./AuthenticationStepper.vue?vue&type=template&id=482f71d8&scoped=true&"
import script from "./AuthenticationStepper.vue?vue&type=script&lang=js&"
export * from "./AuthenticationStepper.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationStepper.vue?vue&type=style&index=0&id=482f71d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f71d8",
  null
  
)

export default component.exports